document.addEventListener('DOMContentLoaded', function () {
  // Accordion linklist two-columns
  document.querySelectorAll('.accordion-details__content.linklist--vertical').forEach(function (ul) {
    if (ul.querySelectorAll('li').length > 5) {
      ul.classList.add('linklist--two-columns');
    }
  });
});

/*
  On tablet and mobile (below 1024px), place the product price under the
  app variant picker (.mpg-swatch), with the theme divider between them.
  Desktop order is left as authored.
*/
(function () {
  var smallScreen = window.matchMedia('(max-width: 1023.98px)');
  var positioning = false;

  function lastSwatch(container) {
    var swatches = container.querySelectorAll('.mpg-swatch');
    var last = null;

    swatches.forEach(function (swatch) {
      if (swatch.parentElement && swatch.parentElement.closest('.mpg-swatch')) return;
      if (swatch.closest('.product__block--price')) return;
      last = swatch;
    });

    return last;
  }

  function dividerFor(container) {
    var divider = container.querySelector('.product__block--price-divider');
    if (divider) return divider;

    divider = document.createElement('div');
    divider.className = 'product__block product__block--divider product__block--price-divider';
    divider.setAttribute('aria-hidden', 'true');
    divider.innerHTML = '<div class="product__divider no-empty"></div>';
    return divider;
  }

  function anchorFor(price) {
    if (price._priceAnchor && price._priceAnchor.parentNode) return price._priceAnchor;

    var marker = document.createComment('product-price-anchor');
    price.before(marker);
    price._priceAnchor = marker;
    return marker;
  }

  function layoutContainer(container) {
    var price = container.querySelector('.product__block--price');
    if (!price) return;

    var swatch = lastSwatch(container);
    var anchor = price._priceAnchor;

    if (smallScreen.matches && swatch) {
      var divider = dividerFor(container);
      if (swatch.nextElementSibling === divider && divider.nextElementSibling === price) return;

      anchorFor(price);
      swatch.after(divider);
      divider.after(price);
      return;
    }

    if (anchor && anchor.parentNode && anchor.nextSibling !== price) {
      anchor.after(price);
    }

    var divider = container.querySelector('.product__block--price-divider');
    if (divider) divider.remove();
  }

  function layout() {
    if (positioning) return;
    positioning = true;

    try {
      document.querySelectorAll('.product__info-container').forEach(layoutContainer);
    } finally {
      positioning = false;
    }
  }

  function swatchWasAdded(mutations) {
    return mutations.some(function (mutation) {
      return Array.prototype.some.call(mutation.addedNodes, function (node) {
        if (node.nodeType !== 1) return false;
        return node.classList.contains('mpg-swatch') || node.classList.contains('product__info-container') || !!node.querySelector('.mpg-swatch, .product__info-container');
      });
    });
  }

  function init() {
    layout();
    smallScreen.addEventListener('change', layout);

    var root = document.querySelector('.site-wrapper') || document.body;
    var observer = new MutationObserver(function (mutations) {
      if (positioning || !swatchWasAdded(mutations)) return;
      layout();
    });

    observer.observe(root, { childList: true, subtree: true });
    document.addEventListener('shopify:section:load', layout);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
